// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hF-z","hovered":"iF-z","hoverImage":"jF-z","mainImage":"kF-z","imageNoBackground":"lF-z","fullSizeImage":"mF-z"};